// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--0d3b8";
export var headingContainer = "index-module--heading-container--66699";
export var highlight = "index-module--highlight--74032";
export var highlightLine = "index-module--highlight-line--3ab5e";
export var image1 = "index-module--image-1--19fb2";
export var image2 = "index-module--image-2--49256";
export var imageContainer = "index-module--image-container--ca013";